export function formatLotCount(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  const rounded = Math.round(n * 100) / 100;
  if (Math.abs(rounded - Math.round(rounded)) < 0.001) {
    return String(Math.round(rounded));
  }
  return rounded.toFixed(2);
}

function positionVariant(row) {
  return String((row && row.lotVariant) || 'MEGA').trim().toUpperCase() === 'MINI' ? 'MINI' : 'MEGA';
}

function sameScript(row, stock) {
  const id = String((stock && (stock.instrumentIdentifier || stock.id)) || '');
  const otherId = String((row && (row.stockId || row.instrumentIdentifier)) || '');
  if (id && otherId && id === otherId) return true;
  const exchange = String((stock && stock.exchange) || '').trim().toUpperCase();
  const name = String((stock && (stock.dispname || stock.dispName || stock.stockName)) || '').trim().toUpperCase();
  const otherExchange = String((row && row.exchange) || '').trim().toUpperCase();
  const otherName = String((row && (row.stockName || row.dispname)) || '').trim().toUpperCase();
  return exchange !== '' && name !== '' && exchange === otherExchange && name === otherName;
}

export function openedLotsForScript(netPositions, stock, lotVariant, fallbackLotSize) {
  const wanted = String(lotVariant || 'MEGA').toUpperCase() === 'MINI' ? 'MINI' : 'MEGA';
  let lots = 0;
  let quantity = 0;
  let netTotal = 0;
  (Array.isArray(netPositions) ? netPositions : []).forEach((position) => {
    if (positionVariant(position) !== wanted) return;
    if (!sameScript(position, stock)) return;
    const net = Number(position.netQty);
    const signed = Number.isFinite(net)
      ? net
      : (Number(position.buyQty || 0) - Number(position.sellQty || 0));
    const qty = Math.abs(signed);
    const lotSize = Number(
      position.usedLotSize
      || position.lotSize
      || position.stockLotSize
      || fallbackLotSize
      || (stock && stock.lotsize)
      || 1
    ) || 1;
    if (qty > 0 && lotSize > 0) {
      quantity += qty;
      lots += qty / lotSize;
      netTotal += signed;
    }
  });
  return {
    quantity,
    lots,
    side: netTotal > 0 ? 'Buy' : netTotal < 0 ? 'Sell' : '',
  };
}
